/* index.js */

"use strict";

/**
 * @module json-editor
 *
 * Public surface for the framework-agnostic, vanilla-DOM JSON editor. Wraps
 * Ace with Ajv schema validation and inline gutter markers. Consumers should
 * import from this entry point rather than reaching into `src/app/*` directly.
 *
 *   const {create, SchemaValidator} = require("@gluenetworks/json-editor");
 *
 * - `create(options)` builds an editor bound to a host element.
 * - `SchemaValidator` exposes `parseJson` / `validate` / `pointerToLineColumn`
 *   for consumers that layer their own domain validation on top.
 */
module.exports = {
    create: require("./app/json_editor.dom").create,
    SchemaValidator: require("./app/utils/json_schema_validator"),
};
